<script setup lang="ts">
import {ref} from "vue";
import VEditableTable from "@/scripts/components/app/qrcodes/batch/Type/VEditableTable.vue";
import {ArrowUpTrayIcon} from "@heroicons/vue/24/outline";
import VFileInput from "@/scripts/components/app/common/VFileInput.vue";
import {FileType} from "@/scripts/api/storage";

const tabs = [
    {name: 'Ввести данные', href: '#', id: 'table'},
    {name: 'Загрузить файл', href: '#', id: 'file'},
]
const selectedTab = ref(tabs[0])
const columns = ref([])

const emit = defineEmits(['changed']);

const changeTab = (tab) => {
    selectedTab.value = tab
}

const tableChanged = (changedColumns) => {
    columns.value = changedColumns
    emit('changed', columns.value)
}

const fileChanged = (file) => {
    emit('changed', file)
}

</script>

<template>
    <div>
        <div class="sm:hidden">
            <label for="tabs" class="sr-only">Select a tab</label>
            <select id="tabs" name="tabs"
                    class="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm">
                <option v-for="tab in tabs" :key="tab.name" :selected="tab.id == selectedTab.id"
                        @change="changeTab(tab)">{{ tab.name }}
                </option>
            </select>
        </div>
        <div class="hidden sm:block">
            <div class="border-b border-gray-200">
                <nav class="-mb-px flex space-x-8" aria-label="Tabs">
                    <a @click="changeTab(tab)" v-for="tab in tabs" :key="tab.name" :href="tab.href"
                       :class="[tab.id == selectedTab.id ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700', 'whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium']"
                       :aria-current="tab.current ? 'page' : undefined">{{ tab.name }}</a>
                </nav>
            </div>
        </div>
    </div>

    <div v-if="selectedTab.id == 'table'">
        <v-editable-table :titles="['Название QR кода', 'Ссылка']" @changed="tableChanged"></v-editable-table>
    </div>

    <div v-if="selectedTab.id == 'file'">
        <div class="rounded-md bg-blue-50 p-4">
            <div class="flex">
                <div class="flex-shrink-0">
                    <ArrowUpTrayIcon class="h-5 w-5 text-blue-400" aria-hidden="true"/>
                </div>
                <div class="ml-3">
                    <div>
                        Пожалуйста, загрузите XLS, или XLSX файл в следующем формате:
                        <ul class="mt-2">
                            <li>1. Колонка A: QR Code Имя (опционально)</li>
                            <li>2. Колонка B: URL</li>
                        </ul>
                    </div>

                    <div class="mt-2">
                       <v-file-input @change="fileChanged" :type="FileType.Xls" :load-untouched="false"></v-file-input>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>